import _ from 'lodash';
import React from 'react';
import Enroll from '../Enroll';
import EnrollSimple from '../EnrollSimple';

const SIMPLE_CODES = ['denver', 'edu'];

const EnrollWrapper = (props) => {
  const { currentUser, match } = props;
  const { params } = match;
  const { code } = params;

  if (_.includes(SIMPLE_CODES, code)) {
    return <EnrollSimple currentUser={currentUser} code={code} />;
  }

  return <Enroll currentUser={currentUser} code={code} />;
};

export default EnrollWrapper;
